module.exports = __webpack_public_path__ + "img/1f6f9.5b5e05e.svg";